import { DEFAULT_SCOUT_POSITION } from '../../../pages/Scout/ScoutResults/ScoutResults.constants';

export const createVideoSlice = (set) => ({
  // --- State ---
  videoModalOpen: false,
  selectedStatName: '',
  selectedPlayerId: '',
  selectedTeamId: '',
  selectedTitle: '',
  selectedPosition: DEFAULT_SCOUT_POSITION,
  token: null,
  selectedGameId: '',
  // --- Actions ---
  setToken: (token) => set({ token }),
  setVideoModalOpen: ({
    videoModalOpen,
    selectedStatName = '',
    selectedPlayerId = '',
    selectedTeamId = '',
    selectedTitle = '',
    selectedPosition = DEFAULT_SCOUT_POSITION,
    selectedGameId = '',
  }) =>
    set({
      videoModalOpen,
      selectedStatName,
      selectedPlayerId,
      selectedTeamId,
      selectedTitle,
      selectedPosition,
      selectedGameId,
    }),
});
